import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fetchWrapper from "../utils/httpClient";
import { API_ESIM_QUERY } from "../utils/apis";

export const exportEsimQuery = createAsyncThunk(
  'esimQuery/exportEsimQuery',
  async (queryParams = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== '') params.append(key, value);
      });

      const url = `${API_ESIM_QUERY}/export${params.toString() ? `?${params}` : ''}`;
      const blob = await fetchWrapper.getFile(url);

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', `esim-query-${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return blob;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchEsimQuery = createAsyncThunk(
  'esimQuery/fetchEsimQuery',
  async (queryParams = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== '') params.append(key, value);
      });

      const url = `${API_ESIM_QUERY}${params.toString() ? `?${params}` : ''}`;
      const response = await fetchWrapper.get(url);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const esimQuerySlice = createSlice({
  name: 'esimQuery',
  initialState: {
    data: null,
    loading: false,
    error: null,
    queryParams: {},
    pagination: {
      pageNumber: 0,
      totalRecords: 0,
      totalPages: 0,
      pageSize: 10
    },
    exportLoading: false
  },
  reducers: {
    clearEsimQuery: (state) => {
      state.data = null;
      state.error = null;
      state.queryParams = {};
      state.pagination = {
        pageNumber: 0,
        totalRecords: 0,
        totalPages: 0,
        pageSize: 10
      };
    },
    setQueryParams: (state, action) => {
      state.queryParams = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEsimQuery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEsimQuery.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.resdata.content;
        state.pagination = {
          pageNumber: action.payload.pageNumber,
          totalRecords: action.payload.totalRecords,
          totalPages: action.payload.resdata.totalPages,
          pageSize: action.payload.resdata.size
        };
      })
      .addCase(fetchEsimQuery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
      })
      .addCase(exportEsimQuery.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportEsimQuery.fulfilled, (state) => {
        state.exportLoading = false;
      })
      .addCase(exportEsimQuery.rejected, (state, action) => {
        state.exportLoading = false;
        state.error = action.payload;
      });
  }
});

export const {
  clearEsimQuery,
  setQueryParams,
  setPagination
} = esimQuerySlice.actions;

export default esimQuerySlice.reducer;